<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  action: { type: String, required: true },
  fieldName: { type: String, required: true },
  fieldValue: {
    type: [String, Number, Boolean, Array, Object],
    default: () => ({}),
  },
});

const from = computed(() => {
  if (Array.isArray(props.fieldValue)) {
    return props.fieldValue[0];
  }

  if (props.action === 'destroy') {
    return props.fieldValue;
  }
  return null;
});

const to = computed(() => {
  if (Array.isArray(props.fieldValue)) {
    return props.fieldValue[1];
  }

  if (props.action === 'destroy') {
    return null;
  }
  return props.fieldValue;
});

const fromText = computed(() => {
  const value = from.value;
  if (!value) return null;

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return value;
});

const toText = computed(() => {
  const value = to.value;
  if (!value) return null;

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return value;
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-1">
    <span class="text-xs text-n-slate-12 font-bold">{{ fieldName }}</span>

    <div class="flex justify-start items-center gap-2 text-xs">
      <div class="text-xs text-n-slate-12 max-w-[calc(50%)] break-all">
        <span v-if="from">
          {{ fromText }}
        </span>
        <span v-else class="text-n-slate-10">{{
          t('WGPT_AUDIT_TRAIL.COMMON.NONE')
        }}</span>
      </div>

      <Icon
        icon="i-lucide-arrow-right"
        class="size-4 text-n-slate-10 shrink-0 rtl:rotate-180"
      />

      <div class="text-xs text-n-slate-12 max-w-[calc(50%)] break-all">
        <span v-if="to">
          {{ toText }}
        </span>
        <span v-else class="text-n-slate-10">{{
          t('WGPT_AUDIT_TRAIL.COMMON.NONE')
        }}</span>
      </div>
    </div>
  </div>
</template>
